/**
 * Returns a promise that resolves after the specified delay, with the
 * optionally specified value.
 */
export const delay = <T>(durationMillis: number, value?: T) =>
  new Promise<T>((resolve) => {
    setTimeout(() => resolve(value as T), durationMillis);
  });
